import { styled } from '@mui/material/styles'

export const DetailLabel = styled('span', {
  name: 'DetailLabel',
  slot: 'Root',
  skipSx: true,
})`
  display: block;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: theme.palette.text.primary;
`
